<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MtrbAddMain from "@/views/MessageManagement/MtrbManage/TabChild/MtrbAddMain";
export default {
  name: "MtrbAdd",
  components: {
    childTab1: MtrbAddMain,
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>